export default __webpack_public_path__ + "static/media/otros.fc188461.svg";